<template>
  <div class="plat-class-teacher-password">
    <div class="main-cont">
      <PasswordLayout ref="password"
                      complex></PasswordLayout>
    </div>
    <div class="footer">
      <el-button size="mini"
                 type="primary"
                 :disabled="committing"
                 @click="handleApply">提交保存</el-button>
      <el-button size="mini"
                 type="default"
                 @click="handleClose">取消操作</el-button>
    </div>
  </div>
</template>

<script>
import PasswordLayout from '../../../../../../../widgets/PasswordLayout'
export default {
  name: 'PlatClassTeacherPassword',
  components: {
    PasswordLayout
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    visible: Boolean
  },
  data () {
    return {
      committing: false
    }
  },
  methods: {
    handleApply () {
      let password = this.$refs.password
      if (password) {
        password.getPassword().then(result => {
          this.committing = true
          this.$ajax({
            url: '/workspace/manager/plat/management/peClassTeacher/updatePassword',
            method: 'post',
            data: this.$qs.stringify(this.$extend({
              postId: this.rowData.id
            }, result))
          }).then(response => {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                this.$message.success(response.data['message'])
                this.$nextTick(() => {
                  this.$emit('hidePopover')
                })
                break
              }
              default: {
                this.$message.warning(response.data['message'])
                break
              }
            }
          }, () => {
            this.$message.error('请求发送失败，请稍后重试')
          }).finally(() => {
            this.committing = false
          })
        }, () => {})
      }
    },
    handleClose () {
      this.$emit('hidePopover')
    }
  },
  watch: {
    visible: function (val) {
      if (!val) {
        let password = this.$refs.password
        if (password) {
          password.resetPassword()
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .plat-class-teacher-password {
    & > .main-cont {
      padding: 15px;
    }
    & > .footer {
      height: 52px;
      background-color: #fff;
      border-top: 1px solid rgba(0,0,0,.05);
      text-align: center;
      line-height: 50px;
    }
  }
</style>
